import { render } from "./subject.vue?vue&type=template&id=562d923e&scoped=true"
import script from "./subject.vue?vue&type=script&lang=js"
export * from "./subject.vue?vue&type=script&lang=js"

import "./subject.vue?vue&type=style&index=0&id=562d923e&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-562d923e"]])

export default __exports__